export const getTimezone = (state: string) => {
    switch (state) {
        case 'NJ':
            return 'America/New_York';
        case 'MI':
            return 'America/New_York';
        case 'PA':
            return 'America/New_York';
        case 'WV':
            return 'America/New_York';
        case 'CT':
            return 'America/New_York';
        case 'MR':
            return 'America/New_York';
        case 'ON':
            return 'America/Toronto';
        case 'AB':
            return 'America/Edmonton';
        default:
            break;
    }
};
